
import { Component, Vue } from 'nuxt-property-decorator';
import toastService, { IToast, ToastType } from './ToastService';
import CloseBtn from '@/components/ui/side-panel/CloseBtn.vue';

@Component({
  components: { CloseBtn },
  // https://dev.to/kouts/create-wrapper-components-for-vuetify-components-2aah
  inheritAttrs: false
})
export default class Toast extends Vue {
  get closeBtnTopValue(): string {
    return this.$vuetify.breakpoint.xsOnly ? '0.8rem' : '0.4rem';
  }

  get closeBtnRightValue(): string {
    return this.$vuetify.breakpoint.xsOnly ? '2.4rem' : '1.2rem';
  }

  get commonAttrs() {
    return {
      light: true,
      right: true,
      bottom: true,
      timeout: toastService.state?.toast?.timeout,
      tile: true,
      elevation: 0,
      transition: 'custom-slide-x-reverse-transition'
    };
  }

  get toast(): IToast | null {
    return toastService.toast;
  }

  get type(): string {
    switch (toastService.toastType) {
      case ToastType.Success:
        return '$sys-checkmark';
      case ToastType.Error:
        return '$sys-error';
      case ToastType.Warning:
        return '$sys-warning';
      case ToastType.Loading:
        return '$sys-download';
      default:
        return '$sys-checkmark';
    }
  }

  closeToast(): void {
    toastService.hideToast();
  }
}
